/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useCallback } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import { RouterStore } from '../router-store/index.tsx';
import type {
	EntireRouterState,
	AllRouterActions,
	HistoryUpdateType,
} from '../router-store/types.tsx';

const useCreateQueryParam = createHook<
	EntireRouterState,
	AllRouterActions,
	string,
	{ paramKey: string }
>(RouterStore, {
	// oxlint-disable-next-line no-explicit-any
	selector: ({ query }: { query: any }, { paramKey }): string => query[paramKey],
});

/**
 * Utility hook for accessing URL query params
 */
export const useQueryParam = (
	paramKey: string,
): [string | undefined, (newValue: string | undefined, updateType?: HistoryUpdateType) => void] => {
	const [paramVal, routerActions] = useCreateQueryParam({ paramKey });

	const setQueryParam = useCallback(
		(newValue: string | undefined, updateType?: HistoryUpdateType) => {
			routerActions.updateQueryParam({ [paramKey]: newValue }, updateType);
		},
		[paramKey, routerActions],
	);

	return [paramVal, setQueryParam];
};
